import { createContext } from "react";
const CouponsContext = createContext();
export default CouponsContext;

